

import { CircularProgress } from '@mui/material';
import { styled } from '@mui/system';

const Spinner = styled('div')(() => ({
  height: '100%',
  flex: 1,
  ".loader-container": {
    height: "100%",
    display: "flex",
    justifyContent: "center",
    alignItems: "center",
    // background: "rgb(63 81 181 / 2%)",
    zIndex: 1,
},

".spinner": {
    width: "64px",
    height: "64px",
    border: "8px solid",
    borderColor: "#3d5af1 transparent #3d5af1 transparent",
    borderRadius: "50%",
    animation: "spin-anim 1.2s linear infinite",
},

"@keyframes spin-anim": {
    "0%": {
        transform: "rotate(0deg)"
    },
    "100%": {
        transform: "rotate(360deg)"
    }
}
}))

const Loader = () => {
  return (
    <Spinner>
      <div className="loader-container">
        <CircularProgress thickness={3}/>
      </div>
    </Spinner>

  )
}

export default Loader;